<div id="no-permissions" *ngIf="!hasPermission">
  <ui-icon [iconClass]="'ui-1_lock-open'"></ui-icon>
  <h1>{{ (roleId ? "no_permit_edit_roles" : "no_permit_create_new_roles") | localize }}</h1>
  <h2>{{ "contact_admin" | localize }}</h2>
</div>

<div id="create-form" *ngIf="hasPermission">
  <div class="gh-f-title-medium">{{ (roleId ? "edit_role" : "create_new_role") | localize }}</div>
  <form #roleForm="ngForm" (ngSubmit)="save()" class="form gh-f-large">
    <div class="gh-fg" *ngIf="initialized">
      <div class="row gh-no-padding gh-no-margin">
        <div class="gh-no-padding gh-no-margin col-md-3 section-name" required>
          {{ "title" | localize }}
        </div>
        <div class="gh-no-padding gh-no-margin col-md-9 gh-input-info">
          <input [(ngModel)]="role.name" class="gh-input-text-v2" autofocus="true" name="name" required data-test-id="role-name" placeholder="{{ 'enter_role_title' | localize }}" />
        </div>
      </div>

      <div class="row gh-no-padding gh-no-margin">
        <div class="gh-no-padding gh-no-margin col-md-3 section-name">
          {{ "description" | localize }}
        </div>
        <div class="gh-no-padding gh-no-margin col-md-9 gh-input-info">
          <textarea
            [(ngModel)]="role.description"
            class="gh-textarea-v2 text-v2"
            name="description"
            maxlength="{{ maxDescriptionLength }}"
            data-test-id="role-description"
            placeholder="{{ 'enter_role_description_max_len_170' | localize }}"></textarea>
        </div>
      </div>

      <div class="form-actions mt-30px mb-10px">
        <button gh-button type="submit" class="gh-b gh-accent large primary" size="large" kind="primary" data-test-id="create-role-button" data-button="Save" [disabled]="!roleForm.valid">
          {{ (roleId ? "save" : "create_role") | localize }}
        </button>
        <button gh-button class="gh-b large secondary" size="large" kind="secondary" (click)="$event.preventDefault(); cancel()">
          {{ "cancel" | localize }}
        </button>
      </div>
    </div>
    <gh-indicator [ghValue]="loadingIndicator" (onReset)="resetLoadingIndicator()" ghMessage="{{ 'loading' | localize }}"></gh-indicator>
  </form>
  <div class="gh-modal-close-button" (click)="cancel()">
    <ui-icon [iconClass]="'ui-1_simple-remove'"></ui-icon>
  </div>
</div>
